import { AwsRum } from 'aws-rum-web';

const rumEnabled = process.env.VUE_APP_RUM_ENABLED;
let isInterviewApp = process.env.VUE_APP_BASE_IS_INTERVIEW_APP;
if (isInterviewApp == "true" || isInterviewApp == true) {
    if (rumEnabled == "true" || rumEnabled == true) {
    try {
        if (process.env.VUE_APP_RUM_ENVIRONMENT === "qa") {    
            const config = {
                sessionSampleRate: 1,
                guestRoleArn: "arn:aws:iam::805218563120:role/RUM-Monitor-us-east-1-805218563120-2685741166561-Unauth",
                identityPoolId: "us-east-1:267a88da-acb1-4214-8a0f-58d41d3e5d5a",
                endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
                telemetries: ["performance","errors","http"],
                allowCookies: true,
                enableXRay: false
              };
            
              const APPLICATION_ID = 'ae4fea4d-aa58-463e-9e2a-a706ec6e030a';
              const APPLICATION_VERSION = '1.0.0';
              const APPLICATION_REGION = 'us-east-1';
            
              const awsRum = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
              );
        } else if (process.env.VUE_APP_RUM_ENVIRONMENT === "production") {    
            const config = {
                sessionSampleRate: 1,
                guestRoleArn: "arn:aws:iam::805218563120:role/RUM-Monitor-us-east-1-805218563120-7403021166561-Unauth",
                identityPoolId: "us-east-1:b5b6a86c-b78c-46f6-900a-86d170c0abcf",
                endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
                telemetries: ["performance","errors","http"],
                allowCookies: true,
                enableXRay: false
              };
            
              const APPLICATION_ID = 'fc7e102e-a075-4ab3-ba90-b2cad96df5b9';
              const APPLICATION_VERSION = '1.0.0';
              const APPLICATION_REGION = 'us-east-1';
            
              const awsRum = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
              );        
        } else if (process.env.VUE_APP_RUM_ENVIRONMENT === "staging") {    
            const config = {
                sessionSampleRate: 1,
                guestRoleArn: "arn:aws:iam::805218563120:role/RUM-Monitor-us-east-1-805218563120-4503041166561-Unauth",
                identityPoolId: "us-east-1:3d55a475-134e-4270-b74d-4e2a77a08a27",
                endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
                telemetries: ["performance","errors","http"],
                allowCookies: true,
                enableXRay: false
              };
            
              const APPLICATION_ID = 'f19ff9a7-9069-4682-ac99-b21a1355b987';
              const APPLICATION_VERSION = '1.0.0';
              const APPLICATION_REGION = 'us-east-1';
            
              const awsRum = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
              );
        }
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
    }
}
